(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 9083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_login; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/LanguageSwitch/index.tsx + 1 modules
var LanguageSwitch = __webpack_require__(92699);
// EXTERNAL MODULE: ./src/assets/logoText.svg
var logoText = __webpack_require__(17649);
// EXTERNAL MODULE: ./src/pages/login/banner.tsx
var banner = __webpack_require__(67426);
// EXTERNAL MODULE: ./src/pages/login/style/index.module.less
var index_module = __webpack_require__(23876);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconWechat/index.js
var IconWechat = __webpack_require__(81025);
// EXTERNAL MODULE: ./src/assets/google.svg
var google = __webpack_require__(63144);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Spin/index.js + 1 modules
var Spin = __webpack_require__(62258);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Form/index.js + 15 modules
var Form = __webpack_require__(65976);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./src/components/CustomInput/index.tsx
var CustomInput = __webpack_require__(1926);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useFormLogin.ts
var useFormLogin = __webpack_require__(74090);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(1925);
// EXTERNAL MODULE: ./src/utils/useLang.ts
var useLang = __webpack_require__(877);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/login/form.tsx











const initialValues = {
  email: '',
  password: ''
};
function LoginForm(_ref) {
  let {
    onChangeForm
  } = _ref;
  const [form] = Form/* default.useForm */.Z.useForm();
  const router = (0,next_router.useRouter)();
  const t = (0,useLocale/* default */.Z)();
  const lang = (0,useLang/* default */.Z)();
  const isChinese = lang === 'zh-CN'; // let captcha

  const {
    onSubmitClick,
    loading
  } = (0,useFormLogin/* default */.Z)({
    form
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default())["login-form-wrapper"],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default */.Z, {
      form: form,
      className: (index_module_default())["login-form"],
      layout: "vertical",
      initialValues: initialValues,
      size: "large",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
        label: t['login.form.email.placeholder'],
        field: "email",
        rules: [{
          required: true,
          validator: utils/* emailFormValidator */.ql,
          message: t['login.form.email.errMsg']
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
          type: "email",
          placeholder: t['login.form.email.placeholder']
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
        label: t['login.form.password.label'],
        field: "password",
        rules: [{
          required: true,
          message: t['login.form.password.errMsg']
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
          type: "password",
          placeholder: t['login.form.password.placeholder']
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        size: 16,
        direction: "vertical",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default())["login-form-password-actions"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/forgot-password",
            children: t['login.form.forgetPassword']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (index_module_default()).emailLogin,
            onClick: v => onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm('phone'),
            children: t['phone_login']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          type: "primary",
          long: true,
          loading: loading,
          className: (index_module_default())["login-form-btn"],
          id: "captcha-button",
          onClick: onSubmitClick,
          children: t['login.form.login']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          color: '#A7A9C1',
          marginTop: '8px'
        },
        children: [t['login.no.account'], /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: {
            color: '#655AEC',
            cursor: 'pointer',
            marginLeft: '4px'
          },
          onClick: () => {
            router.push('/register');
          },
          children: t['login.signUp']
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./src/pages/login/wechat-login.tsx
var wechat_login = __webpack_require__(19959);
// EXTERNAL MODULE: ./src/pages/login/style/login-en.module.less
var login_en_module = __webpack_require__(30464);
var login_en_module_default = /*#__PURE__*/__webpack_require__.n(login_en_module);
// EXTERNAL MODULE: ./src/pages/login/login-btn.tsx
var login_btn = __webpack_require__(88848);
// EXTERNAL MODULE: ./src/hooks/useGoogleAuth.ts
var useGoogleAuth = __webpack_require__(91012);
// EXTERNAL MODULE: ./src/utils/checkLogin.tsx
var checkLogin = __webpack_require__(23199);
// EXTERNAL MODULE: ./src/hooks/useAfterLogin.ts
var useAfterLogin = __webpack_require__(48059);
// EXTERNAL MODULE: ./src/hooks/useAfterOnboarding.ts
var useAfterOnboarding = __webpack_require__(30473);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(42586);
// EXTERNAL MODULE: ./src/pages/login/phone-form.tsx
var phone_form = __webpack_require__(29056);
;// CONCATENATED MODULE: ./src/pages/login/login-content.tsx




















function LoginContent() {
  const router = (0,next_router.useRouter)();
  const {
    query
  } = router;
  const {
    f = ''
  } = query || {};
  const {
    0: sessionFlag,
    1: setSessionFlag
  } = (0,react.useState)('');
  const {
    0: showWechat,
    1: setShowWechat
  } = (0,react.useState)(false);
  const {
    0: inviteCode,
    1: setInviteCode
  } = (0,react.useState)('');
  const lang = (0,useLang/* default */.Z)();
  const isEnglish = lang === 'en-US';
  const {
    0: componentType,
    1: setComponentType
  } = (0,react.useState)(isEnglish ? 'email' : 'phone');
  const t = (0,useLocale/* default */.Z)();
  const {
    afterLoginSuccess
  } = (0,useAfterLogin/* default */.Z)({
    rememberPassword: false
  });
  const {
    afterRegisterSuccess
  } = (0,useAfterOnboarding/* default */.Z)({
    rememberPassword: false
  });

  const onBindSuccess = data => {
    var _data$user;

    (0,checkLogin/* setToken */.o4)(data === null || data === void 0 ? void 0 : data.access_token);

    if (!(data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && _data$user.role)) {
      afterRegisterSuccess();
    } else {
      afterLoginSuccess();
    }
  };

  const {
    googleAuth,
    isLoading
  } = (0,useGoogleAuth/* default */.Z)({
    onBindSuccess,
    invite_code: inviteCode
  });
  (0,react.useEffect)(() => {
    const curInviteCode = f || localStorage.getItem(constants/* INVITE_CODE_STORAGE */.zX) || '';
    setInviteCode(curInviteCode);
  }, [f]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (login_en_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "captcha-element"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (login_en_module_default()).title,
      children: t['login.welcome']
    }), showWechat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          color: '#403D5A',
          lineHeight: '19px',
          marginBottom: '32px',
          cursor: 'pointer'
        },
        onClick: () => {
          setShowWechat(false);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLeft/* default */.Z, {
          style: {
            marginRight: '8px',
            width: '18px'
          }
        }), t['login.another.way']]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(wechat_login/* default */.Z, {
        type: "login",
        step: "",
        sessionFlag: sessionFlag,
        setSessionFlag: setSessionFlag,
        inviteCode: inviteCode
      }, "login")]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Spin/* default */.Z, {
      loading: isLoading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        direction: "vertical",
        size: 16,
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(google/* default */.Z, {}),
          text: t['login.google'],
          onClick: () => {
            googleAuth();
          }
        }, "google"), /*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconWechat/* default */.Z, {
            style: {
              color: '#00C800',
              width: '24px',
              height: '24px'
            }
          }),
          text: t['login.wechat'],
          onClick: () => {
            setShowWechat(true);
          }
        }, "wechat")]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          marginTop: '16px'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            height: '1px',
            flex: 1,
            backgroundColor: '#F0F1F8'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            margin: '0 8px',
            color: '#403D5A'
          },
          children: t['register.or']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            height: '1px',
            flex: 1,
            backgroundColor: '#F0F1F8'
          }
        })]
      }), componentType === 'email' ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoginForm, {
        onChangeForm: v => {
          setComponentType(v);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(phone_form/* default */.Z, {
        onChangeForm: v => {
          setComponentType(v);
        }
      })]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/H1Seo/index.tsx
var H1Seo = __webpack_require__(82578);
// EXTERNAL MODULE: ./src/hooks/useLocalUserInfo.ts
var useLocalUserInfo = __webpack_require__(76313);
;// CONCATENATED MODULE: ./src/pages/login/index.tsx















function Login() {
  const t = (0,useLocale/* default */.Z)();
  const {
    getLocalUserInfo
  } = (0,useLocalUserInfo/* default */.Z)();
  const userInfo = getLocalUserInfo();
  const router = (0,next_router.useRouter)();
  (0,react.useEffect)(() => {
    document.body.setAttribute('arco-theme', 'light');

    if (userInfo) {
      router.push('/board');
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (index_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(H1Seo/* default */.Z, {
      content: "TikTok Shop Seller, Data Analytics, Influencer, login/sign up page"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).logo,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(logoText/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["logo-text"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).banner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["banner-inner"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(banner/* default */.Z, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).contentHeader,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
          size: 24,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/board",
            className: (index_module_default()).headerLink,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (index_module_default()).headerLink,
              children: t['login.home']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/register",
            className: (index_module_default()).headerLink,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (index_module_default()).headerLink,
              children: t['login.signUp']
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSwitch/* default */.Z, {
          theme: "light"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default())["content-inner"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoginContent, {})
      })]
    })]
  });
}

Login.displayName = 'LoginPage';
/* harmony default export */ var login = (Login);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/space/index.js + 1 modules
var space = __webpack_require__(15057);
// EXTERNAL MODULE: ./src/mobile-pages/login/style/index.module.less
var style_index_module = __webpack_require__(62202);
var style_index_module_default = /*#__PURE__*/__webpack_require__.n(style_index_module);
// EXTERNAL MODULE: ./src/mobile-pages/login/wechat-login.tsx
var login_wechat_login = __webpack_require__(58089);
// EXTERNAL MODULE: ./src/mobile-components/MobileLangSwitch/index.tsx
var MobileLangSwitch = __webpack_require__(30567);
// EXTERNAL MODULE: ./src/mobile-pages/login/phone-login.tsx
var phone_login = __webpack_require__(50011);
;// CONCATENATED MODULE: ./src/mobile-pages/login/index.tsx
























const login_initialValues = {
  email: '',
  password: ''
};

const login_Login = () => {
  const router = (0,next_router.useRouter)();
  const {
    query
  } = router;
  const {
    f = ''
  } = query || {};
  const t = (0,useLocale/* default */.Z)();
  const [form] = Form/* default.useForm */.Z.useForm();
  const {
    0: showWechat,
    1: setShowWechat
  } = (0,react.useState)(false);
  const {
    0: sessionFlag,
    1: setSessionFlag
  } = (0,react.useState)('');
  const {
    0: inviteCode,
    1: setInviteCode
  } = (0,react.useState)('');
  const lang = (0,useLang/* default */.Z)();
  const isEnglish = lang === 'en-US';
  const isChinese = lang === 'zh-CN';
  const {
    0: componentType,
    1: setComponentType
  } = (0,react.useState)(isEnglish ? 'email' : 'phone');
  const {
    onSubmitClick,
    loading
  } = (0,useFormLogin/* default */.Z)({
    form
  });
  (0,react.useEffect)(() => {
    const curInviteCode = f || localStorage.getItem('invite_code') || '';
    setInviteCode(curInviteCode);
  }, [f]);
  const {
    afterLoginSuccess
  } = (0,useAfterLogin/* default */.Z)({
    rememberPassword: false
  });
  const {
    afterRegisterSuccess
  } = (0,useAfterOnboarding/* default */.Z)({
    rememberPassword: false
  });

  const onBindSuccess = data => {
    var _data$user;

    (0,checkLogin/* setToken */.o4)(data === null || data === void 0 ? void 0 : data.access_token);

    if (!(data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && _data$user.role)) {
      afterRegisterSuccess();
    } else {
      afterLoginSuccess();
    }
  };

  const {
    googleAuth,
    isLoading
  } = (0,useGoogleAuth/* default */.Z)({
    onBindSuccess,
    invite_code: inviteCode
  });

  if (showWechat) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(login_wechat_login/* default */.Z, {
      type: "login",
      setShowWechat: setShowWechat,
      step: "",
      sessionFlag: sessionFlag,
      setSessionFlag: setSessionFlag,
      inviteCode: inviteCode
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "captcha-element"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (style_index_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (style_index_module_default()).lang,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/board",
          children: t['menu.platform.board']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileLangSwitch/* default */.Z, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (style_index_module_default()).title,
        children: t['login.form.title']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(space/* default */.Z, {
        direction: "vertical",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(google/* default */.Z, {}),
          text: t['login.google'],
          onClick: () => {
            googleAuth();
          }
        }, "google"), /*#__PURE__*/(0,jsx_runtime.jsx)(login_btn/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconWechat/* default */.Z, {
            style: {
              color: '#00C800',
              width: '24px',
              height: '24px'
            }
          }),
          text: t['login.wechat'],
          onClick: () => {
            setShowWechat(true);
          }
        }, "wechat")]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (style_index_module_default())["or-wrap"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (style_index_module_default())["or-line"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (style_index_module_default()).or,
          children: t['register.or']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (style_index_module_default())["or-line"]
        })]
      }), componentType === 'email' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default */.Z, {
          form: form,
          layout: "vertical",
          initialValues: login_initialValues,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
            label: t['login.form.email.placeholder'],
            field: "email",
            rules: [{
              required: true,
              validator: utils/* emailFormValidator */.ql,
              message: t['login.form.email.errMsg']
            }],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
              type: "email",
              placeholder: t['login.form.email.placeholder']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Item */.Z.Item, {
            label: t['login.form.password.label'],
            field: "password",
            rules: [{
              required: true,
              message: t['login.form.password.errMsg']
            }],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomInput/* default */.Z, {
              type: "password",
              placeholder: t['login.form.password.placeholder']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (style_index_module_default()).forget,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (style_index_module_default()).phoneLogin,
              onClick: () => {
                setComponentType('phone');
              },
              children: t['phone_login']
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/forgot-password",
              children: t['login.form.forgetPassword']
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "primary",
            long: true,
            id: "captcha-button",
            loading: loading,
            className: (style_index_module_default()).btn,
            onClick: onSubmitClick,
            children: t['login.form.login']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (style_index_module_default())["no-account"],
          children: [t['login.no.account'], /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (style_index_module_default())["no-account-text"],
            onClick: () => {
              router.push('/register');
            },
            children: t['login.signUp']
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(phone_login/* default */.Z, {
        onChangeForm: v => {
          setComponentType(v);
        }
      })]
    })]
  });
};

/* harmony default export */ var mobile_pages_login = (login_Login);
// EXTERNAL MODULE: ./src/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(97588);
;// CONCATENATED MODULE: ./pages/login/index.tsx





const pages_login_Login = () => {
  return (0,useIsMobile/* default */.Z)() ? /*#__PURE__*/(0,jsx_runtime.jsx)(mobile_pages_login, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(login, {});
};

/* harmony default export */ var pages_login = (pages_login_Login);

/***/ }),

/***/ 82578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78999);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



const H1Seo = _ref => {
  let {
    content
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_1___default().h1Seo),
    children: content
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (H1Seo);

/***/ }),

/***/ 73700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(9083);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1Seo":"index_h1Seo__fcPBB"};

/***/ }),

/***/ 62202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__zg3Ha","title":"index_title__NEYbI","forget":"index_forget__abUBv","phoneLogin":"index_phoneLogin__AkGs_","btn":"index_btn__uuGFV","no-account":"index_no-account__IBELC","no-account-text":"index_no-account-text__7SwC0","or-wrap":"index_or-wrap__m9OPf","or-line":"index_or-line___dQwE","or":"index_or__lYjxx","other":"index_other__RiF7H","icon-wrap":"index_icon-wrap__U34Dm","lang":"index_lang__ySZcC"};

/***/ }),

/***/ 30464:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"login-en_title___tV6L"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9458,2403,1077,5976,1885,2031,3228,9928,3767,3220,455,9214,4730,9612,7530,7572,9669,4607,5323,6864,1723,641,7716,6337,9195,1349,7608,5434,3242,7931,1926,4452,5417,6351,1120,5871,236,6611,3097,1954,4347,7634,9509,5287,9,336,9843,8594,1258,5280,9778,7971,1738,6859,9161,6158,4071,3066], function() { return __webpack_exec__(73700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);